export default "<p>admissionv2 works!</p>\n";